//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
import {
  formatRentDate,
  formatDate,
  convertDuration,
} from '@/helpers/filters.js';
import userChecks from '~/mixins/userChecks';
export default {
  name: 'videoItem',
  mixins: [ImageSrcsetMixin, userChecks],
  props: [
    'resource',
    'index',
    'minimal',
    'ratio',
    'type',
    'id',
    'activedate',
    'cover',
  ],
  components: {
    thumb: () => import('~/components/thumb'),
    VideoPreviewThumb: () => import('~/components/VideoPreviewThumb'),
  },
  computed: {
    ...mapState({
      analytics: ({ analyticsStore: { analytics } }) => analytics,
    }),
  },
  data() {
    return {
      hover: false,
      line_complete: false,
    };
  },
  methods: {
    formatDate,
    convertDuration,
    formatRentDate,
    taphandler() {
      if (this.resource.product.name === 'free') {
        this.$router.push('/gratis-sexfilms/' + this.resource.slug);
      } else {
        this.$router.push('/sexfilms/' + this.resource.slug);
      }
    },
    endHandler() {
      if (!this.line_complete) {
        this.cancelAllPreviews();
      }
    },
    hoverHandler(todo) {
      if (this.resource.clips && this.resource.clips[0]) {
        this.hover = todo;
      }
    },
    touchHandler() {
      this.cancelAllPreviews();
      if (this.resource.clips && this.resource.clips[0]) {
        this.startPreview();
      }
    },
    startPreview() {
      this.hover = true;
      setTimeout(() => {
        var element = document.getElementById('video_' + this.resource.id);
        if (element) {
          element.play();
          element.classList.add('active');
          this.line_complete = true;
        }
      }, 500);
    },
    cancelAllPreviews() {
      document.querySelectorAll('.preview').forEach((element) => {
        if (element && element.id != 'video_' + this.resource.id) {
          element.autoplay = false;
          element.load();
          element.classList.remove('active');
        }
      });
      document.querySelectorAll('.line_animation').forEach((element) => {
        if (element && element.id != 'line_' + this.resource.id) {
          element.classList.remove('active');
        }
      });
      this.hover = false;
      this.line_complete = false;
    },
    GoogleAnalyticsClick(resource) {
      this.$emit('analytics', resource);
    },
    favorite(resource) {
      this.$emit('toggleFavorite', resource);
    },
  },
};
